<template>
  <svg
    :width="size"
    :height="size"
    fill="none"
    :viewBox="viewBox"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      v-for="source in pathSource"
      :key="source"
      :d="source"
      fill="currentColor"
    />
  </svg>
</template>
<script>
export default {
  props: {
    icon: {
      type: String,
      required: true,
    },
    icons: {
      type: Object,
      required: true,
    },
    size: {
      type: [String, Number],
      default: '20',
    },
    type: {
      type: String,
      default: 'outline',
    },
    viewBox: {
      type: String,
      default: '0 0 24 24',
    },
  },

  computed: {
    pathSource() {
      // To support icons with multiple paths and provide a graceful fallback when a key is missing
      const iconKey = `${this.icon}-${this.type}`;
      let path = this.icons[iconKey];

      if (!path && this.type !== 'outline') {
        path = this.icons[`${this.icon}-outline`];
      }

      if (!path) {
        return [];
      }

      if (Array.isArray(path)) {
        return path;
      }

      return [path];
    },
  },
};
</script>
